
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { queryAllCategorys } from '@/service/step-five'

function transformData(data: any[]) {
  return data.map(item => {
    if (
      !item.child?.length ||
      item.child.every((sub: any) => !sub.child?.length)
    ) {
      item.disabled = true
    }
    return item
  })
}

@Component({ inheritAttrs: false })
export default class CategoryPicker extends Vue {
  @Prop({ default: () => [] }) defaultSelected!: any[]

  data: any = []
  originalData: any = []
  stageOneSelected: any = null
  stageTwoSelected: any = null
  stageThreeSelected: any[] = []

  get stageTwo(): any[] {
    return (this.stageOneSelected?.child || []).map((s: any) => {
      if (!('checked' in s)) {
        const len = s.child?.length
        if (!len) {
          s.disabled = true
          s.checked = s.indeterminate = false
        } else {
          const count = this.defaultSelected.length && s.child.filter(this.defaultChecked).length
          s.disabled = s.checked = count === len
          s.indeterminate = count > 0 && count < len
        }
      }
      return s
    })
  }

  get stageThree(): any[] {
    return this.stageTwoSelected?.child || []
  }

  async created() {
    this.originalData = transformData(await queryAllCategorys())
    this.restoreData()
  }

  @Watch('stageOneSelected')
  resetStageTwoSelected() {
    this.stageTwoSelected = null
  }

  close() {
    this.$emit('update:visible', false)
  }

  reset() {
    this.stageOneSelected = null
    this.stageTwoSelected = null
    this.stageThreeSelected = []
    this.restoreData()
  }

  restoreData() {
    this.data = JSON.parse(JSON.stringify(this.originalData))
  }

  pick() {
    this.close()
    if (this.stageThreeSelected.length) {
      this.$emit('select', this.stageThreeSelected)
    }
  }

  onStageTwoItemChange(e: any, item: any) {
    const selected = this.stageThreeSelected
    if (e.target.checked) {
      item.child.forEach((child: any) => {
        if (!this.defaultChecked(child) && !selected.includes(child)) {
          selected.push(Object.assign(child, {
            cname_1: this.stageOneSelected.cname,
            cname_2: item.cname,
            cname_3: child.cname,
            cat_id: child.id,
          } as any))
        }
      })
      item.indeterminate = false
    } else {
      this.stageThreeSelected = selected.filter(child => child.fid !== item.id)
      item.indeterminate = item.child.some(this.defaultChecked)
    }
    item.checked = e.target.checked
  }

  onStageThreeItemChange(e: any, item: any) {
    const selected = this.stageThreeSelected
    const index = selected.indexOf(item)
    e.target.checked
     ? index < 0 && selected.push(Object.assign(item, {
        cname_1: this.stageOneSelected.cname,
        cname_2: this.stageTwoSelected.cname,
        cname_3: item.cname,
        cat_id: item.id,
      }))
     : index > -1 && selected.splice(index, 1)

    let count = 0
    const len = this.stageThree.length
    this.stageThree.forEach(s => {
      if (this.defaultChecked(s) || selected.includes(s)) count++
    })
    this.stageTwoSelected.indeterminate = count > 0 && count < len
    this.stageTwoSelected.checked = count === len
  }

  defaultChecked(item: any) {
    return this.defaultSelected.some(s => s.cat_id === item.id)
  }
}
